<template>
  <div>
    <b-row>
      <b-col cols="12" class="border-bottom mb-3 pb-2">
        <strong v-text="title || headerData" />
      </b-col>
      <b-col cols="12">
        <b-alert show variant="info" class="mb-0">
          <i class="fas fa-info-circle fa-lg mr-1" />
          <b v-html="relationPersonAlert" />
        </b-alert>
        <b-form-group
          :label="$lang.from_relation_person_code"
          label-for="azmoon_execute"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.research_manager"
            :rules="$v.from_relation_person_code_selected.$params"
          />
          <selectAsync
            :options="from_relation_person_code_options"
            v-model="$v.from_relation_person_code_selected.$model"
            label="text"
            id="value"
            :asyncFind="getFromRelationPersonCode"
            :loading="from_relation_person_code_Loading"
            :isValid="
              $v.from_relation_person_code_selected.$dirty
                ? !$v.from_relation_person_code_selected.$error
                : null
            "
          />

          <b-form-invalid-feedback
            :state="
              $v.from_relation_person_code_selected.$dirty
                ? !$v.from_relation_person_code_selected.$error
                : null
            "
          >
            <div v-if="!$v.from_relation_person_code_selected.required">
              {{
                $lang.error_required
                  | replace($lang.from_relation_person_code_selected)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-alert show variant="info" class="mb-0">
          <i class="fas fa-info-circle fa-lg mr-1" />
          <b v-html="examPersonAlert" />
        </b-alert>
        <b-form-group
          :label="$lang.research_manager_form"
          label-for="exam_research_manager_selected"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.research_manager_form"
            :rules="$v.exam_research_manager_selected.$params"
          />
          <selectFind
            :allowEmpty="true"
            :options="azmoon_execute_options"
            v-model="$v.exam_research_manager_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.exam_research_manager_selected.$dirty
                ? !$v.exam_research_manager_selected.$error
                : null
            "
            :loading="azmoon_execute_Loading"
          />

          <b-form-invalid-feedback
            :state="
              $v.exam_research_manager_selected.$dirty
                ? !$v.exam_research_manager_selected.$error
                : null
            "
          >
            <div v-if="!$v.exam_research_manager_selected.required">
              {{ $lang.error_required | replace($lang.research_manager_form) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          :label="$lang.research_manager_connection_form"
          label-for="exam_person"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.research_manager_connection_form"
            :rules="$v.exam_person_selected.$params"
          />
          <selectFind
            :allowEmpty="true"
            :options="azmoon_execute_options"
            v-model="$v.exam_person_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.exam_person_selected.$dirty
                ? !$v.exam_person_selected.$error
                : null
            "
            :loading="azmoon_execute_Loading"
          />
          <b-form-invalid-feedback
            :state="
              $v.exam_person_selected.$dirty
                ? !$v.exam_person_selected.$error
                : null
            "
          >
            <div v-if="!$v.exam_person_selected.required">
              {{
                $lang.error_required
                  | replace($lang.research_manager_connection_form)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.state_define"
          label-for="state_define"
          :label-cols="$config.azmoon.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.state_define"
            :rules="$v.state_define_selected.$params"
          />
          <selectFind
            :options="state_define_options"
            v-model="$v.state_define_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.state_define_selected.$dirty
                ? !$v.state_define_selected.$error
                : null
            "
            :loading="state_define_loading"
          />
          <b-form-invalid-feedback
            :state="
              $v.state_define_selected.$dirty
                ? !$v.state_define_selected.$error
                : null
            "
          >
            <div v-if="!$v.state_define_selected.required">
              {{ $lang.error_required | replace($lang.state_define) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" class="text-right">
        <b-button
          type="reset"
          class="mr-2"
          variant="outline-danger"
          @click="closeModal"
        >
          <mdicon name="close" size="20" />
          {{ $lang.close }}
        </b-button>
        <b-button variant="success" @click="submit">
          <mdicon name="check" size="20" />
          {{ $lang.submitButton }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";

export default {
  validations: {
    from_relation_person_code_selected: { required },
    exam_person_selected: { required },
    exam_research_manager_selected: {},
    state_define_selected: { required },
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      exam_person_selected: null,
      exam_research_manager_selected: null,
      azmoon_execute_Loading: false,
      azmoon_execute_options: [],
      from_relation_person_code_Loading: false,
      from_relation_person_code_options: [],
      from_relation_person_code_selected: null,
      state_define_loading: false,
      state_define_options: [],
      state_define_selected: {},
    };
  },
  computed: {
    headerData() {
      return this.items.length
        ? `اختصاص مدیر تحقیق به متقاضی: ${pathOr(
            "",
            ["0", "audience", "parvandeh", "parvandeh_number"],
            this.items
          )} - ${pathOr(
            "",
            ["0", "audience", "person", "name"],
            this.items
          )} ${pathOr(
            "",
            ["0", "audience", "person", "family"],
            this.items
          )} - ${pathOr(
            "",
            ["0", "audience", "person", "national_code"],
            this.items
          )}`
        : null;
    },
    examPersonAlert() {
      const termCaption = pathOr(
        "",
        ["0", "audience", "parvandeh", "term", "caption"],
        this.items
      );
      return `فقط آزمون‌های ایجاد شده با برچسب <b class="text-primary">تحقیق</b> و برای دوره <b class="text-primary">${termCaption}</b> در لیست نمایش داده می شود.`;
    },
    relationPersonAlert() {
      return `فقط پرونده‌هایی نمایش داده می شوند که در فرم "ارتبط مدیر به ارزیاب" بعنوان مدیر تحقیق تعریف شده باشند`;
    },
  },
  methods: {
    pathOr,
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        this.isLoading = false;
        return;
      }
      const parvandehCodeArr = this.items.map((item) => {
        /* guidance: mapping parvandeh codes of all audience */
        const parvandehCode = pathOr(
          null,
          ["audience", "parvandeh", "code"],
          item
        );
        if (parvandehCode) return parvandehCode;
      });
      const payload = {
        research_manager_code: pathOr(
          null,
          ["value"],
          this.from_relation_person_code_selected
        ),
        audience_azmoon_execute_id: pathOr(
          null,
          ["value"],
          this.exam_person_selected
        ),
        research_manager_azmoon_execute_id: pathOr(
          null,
          ["value"],
          this.exam_research_manager_selected
        ),
        term_state_code: pathOr(null, ["value"], this.state_define_selected),
        audience_parvandeh_code: [...parvandehCodeArr],
      };
      this.$emit("submit", payload);
    },
    closeModal() {
      this.$emit("closeModal");
    },
    async getFromRelationPersonCode(query) {
      if (!query || query.length < 2) {
        return;
      }

      try {
        this.from_relation_person_code_Loading = true;

        const url =
          this.$config.api_url +
          this.$config.research.research_manager_combo.replace("{0}", query);
        const response = await this.$httpService.get(url);

        const data = pathOr([], ["data", "data"], response);
        this.from_relation_person_code_options = data.map((x) => {
          const roles = pathOr([], ["parvandeh", "roles"], x);
          const rolesText = roles.length
            ? " - (نقش: " + roles.join("، ") + ")"
            : "";
          return {
            text: `${pathOr(
              "",
              ["parvandeh", "parvandeh_number"],
              x
            )} - ${pathOr("", ["person", "name"], x)} ${pathOr(
              "",
              ["person", "family"],
              x
            )} - ${pathOr("", ["person", "national_code"], x)} ${rolesText}`,
            value: pathOr("", ["parvandeh", "code"], x),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.from_relation_person_code_Loading = false;
      }
    },
    async azmoonExecute() {
      try {
        this.azmoon_execute_Loading = true;
        const parvandeh_code = pathOr(
          null,
          ["0", "audience", "parvandeh", "code"],
          this.items
        );
        const url = `${this.$config.api_url}${this.$config.profile.azmoon_execute_combo}?parvandeh_code=${parvandeh_code}&tag_id[]=2`;
        const response = await this.$httpService.get(url);
        let { data } = response.data;
        this.azmoon_execute_options = data.map((x) => {
          return {
            text: x.caption,
            value: x.id,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.azmoon_execute_Loading = false;
      }
    },
    async getStateDefine() {
      try {
        this.state_define_loading = true;
        const parvandeh_code = pathOr(
          null,
          ["0", "audience", "parvandeh", "code"],
          this.items
        );
        const url = `${this.$config.api_url}${this.$config.research.term_state_combo}?state_name=research&parvandeh_code=${parvandeh_code}`;
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.state_define_options = data.map((x) => {
          return {
            text: pathOr("", ["state_caption"], x),
            value: pathOr(null, ["code"], x),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.state_define_loading = false;
      }
    },
  },
  created() {
    this.azmoonExecute();
    this.getStateDefine();
  },
};
</script>
